<template>
    <div id="userInfo">
        <div class="header">
            <div class="avatar">
                <img :src="userInfo.avatars?pic + userInfo.avatars:require('../../assets/img/avatar.png')" draggable="false" />
            </div>
            <div class="info">
                <p class="u-name">{{ reg.name || reg.realName }}</p>
                <div class="u-status">
                    <span :class="{ active: userInfo.approveStatus == '2' }">
                        {{ isApprove(userInfo.approveStatus) }}
                    </span>
                </div>
            </div>
        </div>
        <div class="content">
            <div class="tit">
                <span>认证信息</span>
            </div>
            <authent-form :from="'user'" :details="reg" :btnText="isApprove(userInfo.approveStatus)" :isConFlag = "isConFlag"></authent-form>
        </div>
    </div>
</template>

<script>
import authentForm from '../Common/AuthentForm.vue'
export default {
    name: "UserInfo",
    components: { authentForm },
    data() {
        return {
            isConFlag: false, //是否开始认证或已认证
            pic: "https://www.orthoday.com/SDpic/common/picSelect?gid=",
            userInfo: "",
            reg: {
                name: "",
                gender: "",
                s_hospital: [],
                w_hospital: "",
                department: "",
                jobTitle: "",
                code:[],
                major:"",
                imageUrl:"",
                localName:"",
                imgGid: "",
            },
        };
    },
    created() {
        let userId = localStorage.getItem("userId");
        !!userId ? this.getUserInfo(userId) : this.$router.push("/");
    },
    computed: {
        isApprove() {
            return status => (status == 2 ? "已认证" : status == 1 ? "审核中" : "未认证");
        }
    },
    methods: {
        getUserInfo(userSelectGid) {
            this.$axios
                .post("/web/user/select", this.$qs.stringify({ chGid: "", userSelectGid }))
                .then(res => {
                    let data = res.data;
                    if (data.code == "1") {
                        let dt = data.result_data[0];
                        this.reg.name = dt.realName;
                        this.reg.department = dt.department;
                        this.reg.jobTitle = dt.jobTitle;
                        this.reg.w_hospital = dt.hospital;
                        this.reg.major = dt.major||"";
                        this.reg.localName = dt.local;
                        if(dt.sex){
                            this.reg.gender = dt.sex == 1 ? "男" : "女";
                        }
                        if (dt.approvePic) {
                            this.reg.imageUrl = this.pic + dt.approvePic;
                            this.reg.imgGid = dt.approvePic;
                        }
                        if (dt.approveStatus=='1'||dt.approveStatus=='2') {
                            this.isConFlag = true;
                        }
                        localStorage.setItem("isConfirm", dt.approveStatus);
                        this.userInfo = dt;
                    } else {
                        this.$message({
                            message: data.message,
                            type: "warning"
                        });
                    }
                })
                .catch(err => console.log("err"));
        },
    }
};
</script>

<style scoped src="../../assets/css/user-info.css"></style>
